import { Easing, Tween } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import ElementComponent from '../../../Component/UI/Element';
import AnimationClip from '../AnimationClip';

export class BotOptInDecorationScaleUp extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        let element: ElementComponent;

        try {
            element = gameObject.getComponent(ElementComponent);
        } catch (error) {
            console.warn(error);
            return;
        }

        const scaleTween: Tween = this.getTween(element.layout.scale);
        scaleTween.to({ 0: 1, 1: 1 }, 500).easing(Easing.Back.Out);

        yield* this.startTween(scaleTween);
    }
}
